import { Component, OnInit,  ViewChild , Output, EventEmitter} from '@angular/core';
import { Region } from './region/region-model';
import { RegionListComponent } from './region-list/region-list.component';
import { DepartmentListComponent } from './department-list/department-list.component';
import { Department } from './department/department.model';
@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.scss']
})
export class AreaComponent implements OnInit {

  @ViewChild(RegionListComponent, { static: false }) regionListComponent: RegionListComponent;

  @ViewChild(DepartmentListComponent, { static: false }) departmentListComponent: DepartmentListComponent;

  public region: Region = new Region();

  public department: Department = new Department();

  public regionList: [];

  public selectedAreaType: number = 0;


  constructor() { }

  ngOnInit() {
  }


  public refreshRegion(){
    if(this.regionListComponent){
      this.regionListComponent.readRegion();
    }
  }

  public refreshDepartment(){
    if(this.regionListComponent){
      this.departmentListComponent.readDepartment();
    }
  }

  public onRegionEdit(data: Region) {
    this.selectedAreaType = 0;
    this.region = data;
  }

  public onDepartmentEdit(data: any ){
    this.selectedAreaType = 1;
    this.department = {  departmentId: data.id, departmentName: data.name };
  }
}
